module.exports = __webpack_public_path__ + "img/product-5-dian.ad8fd76d.png";